import React, { useEffect, useState } from "react";
import { Space, Tabs, Typography, message, Card, Alert } from "antd";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Sandbox.module.css";
import PreloaderNew from "../UI/PreloaderNew/PreloaderNew";
import Dot from "../UI/Dot";
import SandboxList from "./SandboxList";
import { getSandboxList, getSandboxMyAssets, getSandboxStats } from "../../store/sandbox";
import {
    getSandboxFileErrors,
    getSandboxLoaders,
    getSandboxStatsData,
} from "../../store/sandbox/selectors";
const { Title, Text } = Typography;
const styleTextGray = { color: "#7A7D86" };

function SandboxArea() {
    const [messageApi, contextHolder] = message.useMessage();
    const dispatch = useDispatch();
    const dataStats = useSelector(getSandboxStatsData);
    const isLoader = useSelector(getSandboxLoaders);
    message.config({ duration: 5 });
    const fileError = useSelector(getSandboxFileErrors);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [verdict, setVerdict] = useState(null);
	const [fileType, setFileType] = useState(null)
    const [renew, setRenew] = useState(false);
    const [serial, setSerial] = useState(null);
    const fetchData = () => {
        let filters = false;
        if (search || verdict || fileType || serial)
            filters = {
                search: search,
                verdict__in:
                    verdict === null ? null : verdict === "Malware" ? "1" : "0",
					file_type__in: fileType,
                    firewall_id: serial,
            };

        dispatch(getSandboxList({ filters: filters, page: currentPage }));
    };
    useEffect(() => {
        const timerRefresh = setTimeout(fetchData, 500);
        return () => {
            clearTimeout(timerRefresh);
        };
    }, [currentPage, search, verdict, renew, fileType, serial]);

    useEffect(() => {
        dispatch(getSandboxMyAssets())
        dispatch(getSandboxStats());
    }, [renew]);

    return (
        <Space direction="vertical" size={20} style={{ width: "100%" }}>
            {contextHolder}
            <Title level={3} style={{ margin: 0 }}>
                SANDBOX
            </Title>

            {fileError && (
                <Alert message={fileError} type="error" key={"error"} showIcon>
                    {fileError}
                </Alert>
            )}
            <Card style={{ position: "relative" }}>
                <div className={styles.limitsCards}>
                    <div>
                        <Text>Проверено файлов</Text>
                        <Text style={styleTextGray}>
                            Сегодня: {dataStats?.checked_files_today}{" "}
                        </Text>
                        <Text style={styleTextGray}>
                            Всего: {dataStats?.checked_files_total}{" "}
                        </Text>
                    </div>
                    <div>
                        <div
                            style={{
                                backgroundColor: "#E0F6EA",

                                color: "#219653",

                                display: "inline",
                                borderRadius: 2,
                                padding: "0",
                                paddingLeft: 0,
                                textTransform: "uppercase",
                            }}
                        >
                            BENIGN
                        </div>
                        <Text style={styleTextGray}>
                            Сегодня: {dataStats?.bening_files_today}
                        </Text>
                        <Text style={styleTextGray}>
                            Всего: {dataStats?.bening_files_total}{" "}
                        </Text>
                    </div>
                    <div>
                        <div
                            style={{
                                backgroundColor: "#FFECEC",
                                color: "#EB5757",

                                display: "inline",
                                borderRadius: 2,
                                padding: "0",
                                paddingLeft: 0,
                                textTransform: "uppercase",
                            }}
                        >
                            MALWARE
                        </div>
                        <Text style={styleTextGray}>
                            Сегодня: {dataStats?.malware_files_today}
                        </Text>
                        <Text style={styleTextGray}>
                            Всего: {dataStats?.malware_files_total}
                        </Text>
                    </div>
                </div>
                {isLoader && <PreloaderNew />}
            </Card>
            <SandboxList
                fetchData={fetchData}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setSearch={setSearch}
                setVerdict={setVerdict}
                search={search}
                verdict={verdict}
				renew={renew}
				setRenew={setRenew}
				fileType={fileType}
				setFileType={setFileType}
                serial={serial}
                setSerial={setSerial}
            />
        </Space>
    );
}

export default SandboxArea;
